import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { WorkfileAccessGuard, AuthProvider } from './services';
import { AuthenticationModalComponent } from './authentication-modal';
import { TranslateModule } from '@ngx-translate/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';

@NgModule({
	declarations: [AuthenticationModalComponent],
	imports: [CommonModule, IonicModule, ReactiveFormsModule, FormsModule, TranslateModule],
	providers: [WorkfileAccessGuard, AuthProvider],
	exports: [AuthenticationModalComponent]
})
export class AuthenticationModule {}
